<div [hasPermission]="'publish'" class="embargo">
	<h3>{{ 'EMBARGO' | translate }} 
		<bb-info [contents]="'HELP.EMBARGO' | translate"></bb-info>
	</h3>
	<a class="button set-embargo" *ngIf="!embargo || !embargo.embargoFrom" (click)="getToday()">
		<i class="fa fa-calendar"></i>
		<span>{{ 'SCHEDULE_AVAILABILITY' | translate }}</span>
	</a>

	<bb-form-element *ngIf="embargo && embargo.embargoFrom">
		<div class="date-container">

			<mat-form-field appearance="fill">
				<mat-label>{{ 'AVAILABLE_FROM' | translate }}</mat-label>
				<!-- note 1-way binding for input for correct formatting -->
				<input matInput [matDatepicker]="picker" (ngModelChange)="embargoFromChange($event)" [ngModel]="embargo.embargoFrom">
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>

			<bb-time [(ngModel)]="embargoFromTime" (ngModelChange)="embargoTimeFromChange($event)"></bb-time>
			&nbsp;
			<a class="button remove-embargo" [ngClass]="{'disabled': embargo.embargoTo}" (click)="removeEmbargoFrom()">
				<i class="fa fa-times"></i>
			</a>
		</div>
	</bb-form-element>

	<a class="button margin-top" *ngIf="embargo && embargo.embargoFrom && !embargo.embargoTo" (click)="getDayLater()">
		<span>{{ 'SET_END_DATE' | translate }}</span>
	</a>

	<bb-form-element *ngIf="embargo && embargo.embargoFrom && embargo.embargoTo && showEndDate">
		<div class="date-container">

			<mat-form-field appearance="fill">
				<mat-label>{{ 'AVAILABLE_TO' | translate }}</mat-label>
				<!-- note 1-way binding for input for correct formatting -->
				<input matInput [matDatepicker]="picker" (ngModelChange)="embargoToChange($event)" [ngModel]="embargo.embargoTo">
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>

			<bb-time [(ngModel)]="embargoToTime" (ngModelChange)="embargoTimeToChange($event)"></bb-time>
			&nbsp;
			<a class="button remove-embargo" (click)="removeEmbargoTo();"><i class="fa fa-times"></i></a>
		</div>
	</bb-form-element>
</div>
